import { isBlankValue } from '../../utils/helpers';
import { SyncDataProcessType } from '../sync-data-process-logs/sync-data-process-log';

export enum SyncDataProcessLogHealthCheckErrorType {
  CRITICAL_ERRORS = 'criticalErrors',
  FILE_NOT_VALID = 'fileNotValid',
  FAILED_TASK_DETECTED = 'failedTaskDetected',
}

export const getSyncDataProcessLogHealthCheckNotificationTypeValue = (
  errorType: SyncDataProcessLogHealthCheckErrorType,
  processType?: SyncDataProcessType,
): string =>
  `syncDataProcessLog_${errorType}${
    !isBlankValue(processType) ? `_${processType}` : ''
  }`;

export const SyncDataProcessLogHealthCheckNotificationsType = {
  SYNC_DATA_PROCESS_LOGS_CRITICAL_ERRORS_OPIS_BIO:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.CRITICAL_ERRORS,
      SyncDataProcessType.OPIS_BIO,
    ),
  SYNC_DATA_PROCESS_LOGS_CRITICAL_ERRORS_OPIS_RACK:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.CRITICAL_ERRORS,
      SyncDataProcessType.OPIS_RACK,
    ),
  SYNC_DATA_PROCESS_LOGS_CRITICAL_ERRORS_DTN_PRICES:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.CRITICAL_ERRORS,
      SyncDataProcessType.DTN_PRICES,
    ),

  SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_OPIS_BIO:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FILE_NOT_VALID,
      SyncDataProcessType.OPIS_BIO,
    ),
  SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_OPIS_RACK:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FILE_NOT_VALID,
      SyncDataProcessType.OPIS_RACK,
    ),
  SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_DTN_PRICES:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FILE_NOT_VALID,
      SyncDataProcessType.DTN_PRICES,
    ),

  SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_OPIS_BIO:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FAILED_TASK_DETECTED,
      SyncDataProcessType.OPIS_BIO,
    ),
  SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_OPIS_RACK:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FAILED_TASK_DETECTED,
      SyncDataProcessType.OPIS_RACK,
    ),
  SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_DTN_PRICES:
    getSyncDataProcessLogHealthCheckNotificationTypeValue(
      SyncDataProcessLogHealthCheckErrorType.FAILED_TASK_DETECTED,
      SyncDataProcessType.DTN_PRICES,
    ),
};

export const SyncDataProcessLogHealthCheckNotificationsWithCriticalSeverityLevel: string[] =
  [
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_OPIS_BIO,
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_OPIS_RACK,
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FILE_NOT_VALID_DTN_PRICES,
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_OPIS_BIO,
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_OPIS_RACK,
    SyncDataProcessLogHealthCheckNotificationsType.SYNC_DATA_PROCESS_LOGS_FAILED_TASK_DETECTED_DTN_PRICES,
  ];
